// extracted by mini-css-extract-plugin
export default {"root":"uN95fFwa","edge":"sAg0kAxP","isMin":"zYucqeuU","isMax":"F3Msajno","field":"_2+GDKtLf"};